import { useRef, useEffect } from "react";

const useCategorySlider = (selectedId: number | null) => {
    const sliderRef = useRef<HTMLDivElement | null>(null);
    const cardRefs = useRef<Record<number, HTMLDivElement | null>>({});

    const handleScroll = (direction: 'left' | 'right'): void => {
        if (sliderRef.current) {
            const firstCard = Object.values(cardRefs.current)[0];
            const cardWidth = firstCard?.offsetWidth || 0;
            const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;

            requestAnimationFrame(() => {
                sliderRef.current!.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth',
                });
            });
        }
    };

    useEffect(() => {
        if (selectedId !== null && sliderRef.current) {
            const selectedElement = cardRefs.current[selectedId];
            if (selectedElement) {
                selectedElement.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                });
            }
        }
    }, [selectedId]);

    return { sliderRef, cardRefs, handleScroll };
};

export default useCategorySlider;
